<template>
    <viewer class="pictureBlock" :images="pictures" :options="options">
        <div class="pictureContainer" :key="index" v-for="(picture, index) in pictures">
            <div class="pictureRemove" @click="removePicture(index, pictures[index].fileID, pictures[index].fileHash)">
                <svg role="img" class="icon"><use xlink:href="/images/symbols.svg#ico-close"></use></svg>
            </div>
            <img :src="picture.image" :data-src="picture.imageFull">
        </div>
        <div class="pictureAdd" v-if="createRequest || (status == 'IN_PROGRESS' && isSameInspector)">
            <input id="uploadPicture" type="file" name="myPhoto" accept="image/*" @change="addPicture($event)" />
            <svg role="img" class="icon"><use xlink:href="/images/symbols.svg#ico-add"></use></svg>
        </div>
    </viewer>
</template>

<script>
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import { EventBus } from '@/classes/eventBus.js'

Vue.use(Viewer)

export default {
    name: 'PictureBlockCreate',
    props: {
        sessionID: String,
        requestInspectorPictures: Array,
        createRequest: Boolean
    },
    data() {
        return {
            pictures: [],
            picturesClicked: [],
            pictureToDelete: Object,
            options: {
                'url': 'data-src',
                'button': false,
                'navbar': true,
                'title': false,
                'toolbar': false,
                'tooltip': false,
                'movable': true,
                'zoomable': true,
                'rotatable': true,
                'scalable': true,
                'transition': true,
                'fullscreen': true,
                'keyboard': true
            }
        }
    },
    computed: {
        isSameInspector() {
            return this.$store.getters.isSameInspector(this.$route.params.requestID)
        },
        status() {
            return this.$store.getters.requestStatus(this.$route.params.requestID)
        }
    },
    mounted() {
        for(var j = 0; j < this.requestInspectorPictures.length; j++) {
            this.pictures.push({image: this.requestInspectorPictures[j].thumbPath, imageFull: this.requestInspectorPictures[j].path, pictureID: this.requestInspectorPictures[j].id, isDeletable: true})
        }
        EventBus.$on('removePicture', result => {
            if (result) {
                this.removePictureAccepted(this.pictureToDelete)
            }
        })
        EventBus.$on('addNewImageCreate', result => {
            if (result) {
                this.pictures.push({ fileID: result.fileID, fileHash: result.fileHash, image: result.imageTempPath, imageFull: result.imageTempPath })
            }
        })
    },
    beforeDestroy() {
        EventBus.$off('removePicture')
    },
    methods: {
        addPicture(e) {
            const file = e.target.files[0]
            if (!file) { return }

            var imageTempPath = URL.createObjectURL(event.target.files[0])

            this.$store.dispatch('setNewImageCreate', { sessionID: this.sessionID, filename: file.name, image: file, imageTempPath: imageTempPath })
        },
        removePicture(index, fileID, fileHash) {
            this.pictureToDelete = {index: index, fileID: fileID, fileHash: fileHash}
            EventBus.$emit('openPopup', {'type': 'confirmation', 'title': 'Voulez-vous supprimer la photo?', 'description': 'Cette action est irréversible.', 'actions': this.$t('navigationBar.back.actions'), 'event': 'removePicture' })
        },
        removePictureAccepted(picture) {
            this.$delete(this.pictures, picture.index)
            this.$store.dispatch('removePictureCreate', { fileID: picture.fileID, fileHash: picture.fileHash })
        }
    }
}
</script>